export default "__VITE_ASSET__Dt_B_wSx__"